import { render, staticRenderFns } from "./grupo_usuario.vue?vue&type=template&id=39e5129f&"
import script from "./grupo_usuario.vue?vue&type=script&lang=js&"
export * from "./grupo_usuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports